import React, { useEffect } from "react";
import { Layout } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "../Layouts/MenuMobile";
import TitledPageShell from "../Components/Layout/TitledPageShell";
import { PORTAL_HEADER_CSS_VAR } from "../Components/Layout/PortalUemHeader";

const { Content } = Layout;

export default function MainGraduadoLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("me") ? localStorage.getItem("me") : null);
    const refresh_token = localStorage.getItem("refresh_token") ? localStorage.getItem("refresh_token") : null;
    if (!user || !refresh_token) {
      navigate('/account/login');
    }
  }, [navigate]);

  const showTitleRoutes = [
    '/eventos',
    '/publicar',
    '/vagas',
    '/parceiros',
    '/empregabilidade',
    '/perfil',
    '/minhas-publicacoes',
    '/padrinho',
    '/pedido-colaboracao',
    '/doar',
  ];
  const shouldShowTitle = showTitleRoutes.includes(location.pathname);

  const pageMeta = (() => {
    const meta = {
      '/eventos': {
        title: 'Eventos',
        description: 'Consulte os eventos e veja detalhes.',
      },
      '/publicar': {
        title: 'Publicar',
        description: 'Crie e publique novos conteúdos.',
      },
      '/vagas': {
        title: 'Vagas',
        description: 'Pesquise e acompanhe as oportunidades de emprego.',
      },
      '/parceiros': {
        title: 'Parceiros',
        description: 'Conheça parceiros e oportunidades associadas.',
      },
     '/empregabilidade': {
  title: 'Empregabilidade',
  description: (
    <>
      <span className="font-black-7">
        A Universidade Eduardo Mondlane pretende estar a par da evolução dos seus Graduados no mercado de trabalho e empregabilidade.
        Neste contexto, gostaríamos de solicitar ao Graduado o preenchimento do Inquérito de Estudo de Acompanhamento, clicando no{" "}
      </span>
      <strong>Preencher Inquérito</strong>
    </>
  ),
},
      '/perfil': {
        title: 'Meu Perfil',
        description: 'Veja e actualize os seus dados.',
      },
      '/minhas-publicacoes': {
        title: 'Minhas Publicações',
        description: 'Gira as suas publicações.',
      },
      '/padrinho': {
        title: 'Iniciativa Padrinho',
        description: ' A Iniciativa Padrinho é um programa da Universidade Eduardo Mondlane que visa mobilizar os Alumni, instituições, empresas e individualidades a contribuírem para o apoio académico e social de estudantes carenciados.',
      },
     '/pedido-colaboracao': {
        title: 'Colaboração',
        description: (<>A iniciativa funciona como uma ponte intergeracional entre estudantes, recém-graduados e profissionais formados pela UEM. Neste contexto,  para que o Graduado inicie a sua colaboração,clique no botão <strong>Solicitar Colaboração</strong>      </> ),
      },
      '/doar': {
        title: 'Doações',
        description: 'Contribua para iniciativas e apoie a comunidade Alumni.',
      },
    };
    return meta[location.pathname] || { title: '', description: '' };
  })();

  return (
    <main style={{ backgroundColor: '#ffffff', minHeight: '100vh' }}>
      <Header />

      {shouldShowTitle ? (
        <TitledPageShell title={pageMeta.title} description={pageMeta.description}>
          <Content className="mt-3 rounded-md bg-white p-4 py-6 shadow-sm">
            <Outlet />
          </Content>
        </TitledPageShell>
      ) : (
        <div
          className="flex-grow w-full"
          style={{ paddingTop: `calc(var(${PORTAL_HEADER_CSS_VAR}, 160px) + 16px)` }}
        >
          <div className="mx-auto w-full max-w-[1400px] px-3 md:px-6 2xl:px-0">
            <Content className="mt-6 rounded-md bg-white p-4 py-6 shadow-sm">
              <Outlet />
            </Content>
          </div>
        </div>
      )}

      <Footer />
    </main>
  );
}